import React from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    LifecycleInputDocument,
    LifecycleOutputDocument,
} from "server/models"
import {
    StoreType,
    DriveOnSelectFile,
    createFileName,
    addModal,
} from "client/store"
import {
    TextButton,
    CrossIcon,
    Empty,
    ListWrapper,
    ListItem,
    ListItemTitle,
    DeleteListItemButton,
} from "client/components"

import Drive from "client/pages/drive"


type DocumentType = LifecycleInputDocument | LifecycleOutputDocument

interface PopulateDocumentsProps {
    documents: readonly DocumentType[]
    addAccess: boolean
    deleteAccess: boolean
    onAdd: DriveOnSelectFile
    onDelete: (document: DocumentType) => void
}

const PopulateDocuments = ({
    documents,
    addAccess,
    deleteAccess,
    onAdd,
    onDelete,
}: PopulateDocumentsProps) => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const addDocument = () => {
        dispatch(addModal({
            key: "drive",
            content: <Drive onSelectFile={onAdd} />,
        }))
    }

    return (
        <ListWrapper>
            {
                documents.map((document) => {
                    const { file, fileId, creator } = document
                    return (
                        <ListItem key={fileId}>
                            <ListItemTitle>{createFileName(file)}</ListItemTitle>
                            {
                                (deleteAccess || creator === userData.userId) && (
                                    <DeleteListItemButton onClick={() => onDelete(document)}>
                                        <CrossIcon />
                                    </DeleteListItemButton>
                                )
                            }
                        </ListItem>
                    )
                })
            }
            {
                !documents.length
                && <Empty />
            }
            {
                addAccess
                && <TextButton onClick={addDocument}>{lang.add}</TextButton>
            }
        </ListWrapper>
    )
}
export default PopulateDocuments
